import { WishlistInfo, ProductInfo } from "@/types";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface WishlistState {
  list: ProductInfo[];
}

const initialState: WishlistState = {
  list: [],
};

export const wishlistSlice = createSlice({
  name: 'wishlist',
  initialState,
  reducers: {
    addToWishlist: (state: WishlistState, action: PayloadAction<ProductInfo>) => {
      // Check if product already exists in wishlist
      const existingProduct = state.list.find(
        item => item.articleId === action.payload.articleId
      );

      if (!existingProduct) {
        state.list.push(action.payload);
      }

      return state;
    },
    removeFromWishlist: (state: WishlistState, action: PayloadAction<{ articleId: number }>) => {
      state.list = state.list.filter(
        item => item.articleId !== action.payload.articleId
      );
      return state;
    },
    clearWishlist: (state: WishlistState) => {
      state.list = [];
      return state;
    },
    loadWishlist: (state: WishlistState, action: PayloadAction<WishlistInfo>) => {
      return action.payload;
    }
  }
});

export const { addToWishlist, removeFromWishlist, clearWishlist, loadWishlist } = wishlistSlice.actions;
export default wishlistSlice.reducer;
